import {useDispatch, useSelector} from "react-redux";
import {airtable_config_get_label, searchKeyPress} from "../redux/actions";

export const Search = () => {
    const dispatch = useDispatch()
    const airconfig = useSelector(state => state.app.airconfig)
    const searchValue = useSelector(state => state.app.search)
    const app_lang = useSelector(state => state.app.app_lang)

    const handleKeyPress = (event) => {
        const value = event.target.value
        dispatch(searchKeyPress(value))
    }
    const search_placeholder = airtable_config_get_label(airconfig, 'search_placeholder', app_lang);
    const search_btn = airtable_config_get_label(airconfig, 'search_btn', app_lang);
    return (
        <div className="search">
            <input type="text" name="search"
                   value={searchValue}
                   onChange={(e) => handleKeyPress(e)}
                   placeholder={search_placeholder}/>
                   <button>{search_btn}</button>
        </div>
    )
}